import React from 'react';
import styled from 'styled-components';
import {Typography} from 'epic-ue-ui';

const Styled = styled.div`
    width: 100%;
    height: 250px;
    position: relative;

    .inner {
        height: 100%;
        padding: 0 40px;
        ${p => p.theme.breakpoints.up('xl')} {
            padding: 0;
        }
    }

    .content {
        z-index: 2;
        height: 100%;
        position: relative;
        padding: 0 30px;
        max-width: 1200px;
        margin: 0 auto;
    }

    ${p => p.theme.breakpoints.down('md')} {
        height: 280px;
    }

    .header-bg-image {
        z-index: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
    }

    .ue-grid-container {
        height: 100%;
        padding: 0;
    }

    .header-flex {
        height: 100%;
        display: flex;
        align-items: flex-start;
        flex-direction: column-reverse;
        justify-content: center;

        ${p => p.theme.breakpoints.up('sm')} {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }

        .text {
            display: flex;
            flex-direction: column;
            gap: 10px;

            .title {
                font-family: Inter;
                font-size: 22px;
                line-height: 35px;
                letter-spacing: -0.5px;
            }
            .description {
                font-family: Inter;
                font-size: 14px;
                line-height: 20px;
                letter-spacing: 0.2px;
                color: rgba(255, 255, 255, 0.7);
            }

            ${p => p.theme.breakpoints.up('sm')} {
                max-width: 600px;
                margin-right: 30px;
                gap: 16px;

                .title {
                    font-size: 30px;
                    letter-spacing: -0.3px;
                }
                .description {
                    font-size: 14px;
                    line-height: 20px;
                    letter-spacing: 0.2px;
                }
            }

            ${p => p.theme.breakpoints.up('xl')} {
                .title {
                    font-size: 40px;
                    line-height: 45px;
                    letter-spacing: -0.5px;
                }
                .description {
                    font-size: 16px;
                }
            }
        }

        .logo {
            margin-bottom: 16px;

            .header-logo-image {
                width: 115px;
            }

            ${p => p.theme.breakpoints.up('sm')} {
                margin-bottom: 0;

                .header-logo-image {
                    width: 240px;
                }
            }

            ${p => p.theme.breakpoints.up('xl')} {
                .header-logo-image {
                    width: 260px;
                }
            }
        }
    }
`;

export interface HomeHeaderProps {
    title: string;
    description: string;
    logo: string;
    logoAlt?: string;
    background: string;
    backgroundAlt?: string;
}

export const HomeHeader: React.FC<HomeHeaderProps> = ({
    title,
    description,
    logo,
    logoAlt = 'Dev Epic Games logo',
    background,
    backgroundAlt = 'Header background image'
}): JSX.Element => (
    <Styled>
        <img alt={backgroundAlt} className="header-bg-image" src={background} loading="lazy" />
        <section className="content">
            <div className="inner">
                <div className="header-flex">
                    <div className="text">
                        <Typography variant="h2" as="h1" className="title">
                            {title}
                        </Typography>
                        <Typography variant="p" className="description">
                            {description}
                        </Typography>
                    </div>
                    <div className="logo">
                        <img alt={logoAlt} className="header-logo-image" src={logo} loading="lazy" />
                    </div>
                </div>
            </div>
        </section>
    </Styled>
);
